import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;

const SimpleLoader: React.FC = () => <Spin indicator={antIcon} />;

export default SimpleLoader;
